import { IAuthUserPerfil, AuthUserPerfilId } from './IAuthUserPerfil';

export default ((): IAuthUserPerfil => {
  return {
    id: AuthUserPerfilId.Deslogado,
    nome: "Deslogado",

    associadoRoute: {
      assembleias: {
        pre: {
          ver: false,
          videos: {
            ver: false,
            participar: false
          },
          documentos: {
            ver: false,
            participar: false,
          },
          duvidasSugestoes: {
            ver: false,
            participar: false
          }
        },
        live: {
          ver: false,
          video: {
            ver: false,
            participar: false
          },
          documentos: {
            ver: false,
            participar: false,
          },
          duvidasSugestoes: {
            ver: false,
            participar: false
          }
        },
        pautas: {
          ver: false,
          participar: false
        }
      },
    },
  
    assessorRoute: {
      convocados: {
        view: false,
      },
      assembleias: {
        ver: false,
        alterarSituacao: false,
        bloquearConvocacao: false,
        convocar: false,
        documentos: {
          ver: false,
          editar: false,
        },
        participantes: {
          verTotal: false,
          confirmar: false
        },
        pautas: {
          ver: false,
          alterarSituacao: false,
          incluirVotoManual: false,
          editar: false,
          deletar: false
        },
        cadastroPauta: {
          cadastrar: false
        },
        videos: {
          editar: false,
        },
      },
  
      duvidasSugestoes: {
        ver: false,
        responder: false,
        alterarSituacao: false,
        incluirPergunta: false,
      }
    }
    
  }
})();